<template>
  <component :is="props.tag" :class="['Wrpr-Box', props.className]">
    <slot></slot>
  </component>
</template>

<script setup>
  import { defineProps } from 'vue';
  import { Props } from './scripts/props.js';
  //--------------------------
  const props = defineProps(Props());  
</script>

<style lang="scss">
  @import "./styles/_conf";
</style>